import CommandButton from "./index.vue";
import { CodeBlockHighlight } from "tiptap-extensions";

export default class CodeBlock extends CodeBlockHighlight {
  menuBtnView(p) {
    return {
      component: CommandButton,
      componentEvents: {
        click: () => {
          // 插入一个代码块，插入代码块的形式 insert
          const { commands } = p;
          commands.code_block();
        }
      }
    };
  }
}
